/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { CommunityModule } from '../common/community/community.module';
import { CommunityFeedModule } from '../common/community/feed/community-feed.module';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { SkeletonListComponent } from '../common/components/skeleton-list/skeleton-list.component';
import { ViewPickerComponent } from '../common/components/view-picker/view-picker.component';
import { SearchPageComponent } from './search-page.component';
import { SearchPersonCardComponent } from './search-person-card.component';

// Not standalone: the feed card and follow button pull in UpgradeModule (see CLAUDE.md).
@NgModule({
  imports: [CommonModule, UIRouterModule, SharedModule, CommunityModule, CommunityFeedModule, CommonComponentsModule, SkeletonListComponent, ViewPickerComponent],
  declarations: [SearchPageComponent, SearchPersonCardComponent],
  exports: [SearchPageComponent],
})
class SearchPageModule {}

export { SearchPageModule };
